module.exports = __webpack_public_path__ + "img/runze01.bda6e6e2.png";